/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContractStatus = 'Undefined' | 'Draft' | 'Valid' | 'Effective' | 'Canceled' | 'Terminated';

export const ContractStatus = {
    Undefined: 'Undefined' as ContractStatus,
    Draft: 'Draft' as ContractStatus,
    Valid: 'Valid' as ContractStatus,
    Effective: 'Effective' as ContractStatus,
    Canceled: 'Canceled' as ContractStatus,
    Terminated: 'Terminated' as ContractStatus
};